import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
} from "components/Resume/ResumePDF/common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeWorkExperience } from "lib/redux/types";
import { ResumePDFDescription, TemplateTwentyOnePDFSection, TemplateTwentyOneSectionWithSubsections } from "./common";

export const WorkExperience = ({
  heading,
  workExperiences,
  themeColor,
}: {
  heading: string;
  workExperiences: ResumeWorkExperience[];
  themeColor: string;
}) => {
  return (
    <TemplateTwentyOneSectionWithSubsections themeColor={themeColor} heading={heading}>
      {workExperiences.map(
        ({ company, jobTitle, startDate, endDate, descriptions }, idx) => {
          // Hide company name if it is the same as the previous company
          const hideCompanyName =
            idx > 0 && company === workExperiences[idx - 1].company;

          return (
            <View
              key={idx}
              style={idx !== 0 ? { marginTop: spacing["2"] } : {}}
              wrap={false}
            >
              {!hideCompanyName && (
                <View style={{ flexDirection: "row", alignItems: "center", flexWrap: "wrap" }}>
                <View style={{ flexShrink: 1, marginRight: spacing["0.5"] }}>
                  <ResumePDFText  bold={true}>
                    {jobTitle},
                  </ResumePDFText>
                </View>
                {company && (
                  <View style={{ flexShrink: 1 }}>
                    <ResumePDFText >
                      {`${company}`}
                    </ResumePDFText>
                  </View>
                )}
              </View>
              
              )}
              <View
                style={{
                  ...styles.flexCol,
                  marginTop: hideCompanyName
                    ? "-" + spacing["1"]
                    : spacing["1.5"],
                }}
              >
                <ResumePDFText> 
                  {startDate && endDate
                    ? `${startDate} - ${endDate}`
                    : startDate || endDate}
                </ResumePDFText>
              </View>
              <View style={{ ...styles.flexCol, marginTop: spacing["1.5"] }}>
              <ResumePDFDescription items={descriptions}   />
              </View>
            </View>
          );
        }
      )}
    </TemplateTwentyOneSectionWithSubsections>
  );
};